/** Extraction min/max par colonne de pixels — la base du tracé de forme d'onde. */

export interface Peaks {
  min: Float32Array;
  max: Float32Array;
  columns: number;
}

export function computePeaks(
  buffer: AudioBuffer,
  columns: number,
  from = 0,
  to?: number,
): Peaks {
  const cols = Math.max(1, Math.floor(columns));
  const min = new Float32Array(cols);
  const max = new Float32Array(cols);
  const sr = buffer.sampleRate;
  const a = Math.max(0, Math.floor(from * sr));
  const b = Math.min(buffer.length, Math.floor((to ?? buffer.duration) * sr));
  const span = Math.max(1, b - a);
  const per = span / cols;
  const chans = buffer.numberOfChannels;
  const data: Float32Array[] = [];
  for (let c = 0; c < chans; c++) data.push(buffer.getChannelData(c));

  for (let i = 0; i < cols; i++) {
    const s0 = a + Math.floor(i * per);
    const s1 = Math.min(b, a + Math.floor((i + 1) * per));
    let lo = 0;
    let hi = 0;
    // Sur de longs fichiers on sous-échantillonne : 512 lectures par colonne suffisent.
    const step = Math.max(1, Math.floor((s1 - s0) / 512));
    for (let j = s0; j < s1; j += step) {
      let v = 0;
      for (let c = 0; c < chans; c++) v += data[c][j];
      if (chans > 1) v /= chans;
      if (v < lo) lo = v;
      if (v > hi) hi = v;
    }
    min[i] = lo;
    max[i] = hi;
  }
  return { min, max, columns: cols };
}
